const { outboundConsignment, consignment } = require("./consignment");
const { date, profileCode, generateCustomsData } = require("../shared");
const { getFieldOptions, createModel } = require("../utils");
const { invoice } = require("./invoice");

const createBaseJoiNotation = (_, options) => ({
  shipmentDate: date()
    .required()
    .options(getFieldOptions(options)),
  outboundConsignment: outboundConsignment(
    "outboundConsignment",
    options
  ).required(),
  generateCustomsData: generateCustomsData().options(getFieldOptions(options)),
  invoice: invoice("invoice", options),
  profileCode: profileCode()
    .optional()
    .options(getFieldOptions(options)),
});

exports.domesticShipment = createModel((prefix, options = {}) =>
  createBaseJoiNotation(prefix, options)
);

exports.updateInternationalShipment = createModel((prefix, options = {}) =>
  createBaseJoiNotation(prefix, { ...options, international: true })
);

exports.collectionOnDeliveryShipment = createModel((prefix, options) => ({
  ...createBaseJoiNotation(prefix, options),
  inboundConsignment: consignment("inboundConsignment", options).required(),
}));
